import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/purchase-orders', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/purchase-orders', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/purchase-orders/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/purchase-orders/${data.po_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/purchase-orders/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const getSupplier = (Options = {}) => {
  return httpClient
    .get('/api/purchase-orders/suppliers', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getProduct = (Options = {}) => {
  return httpClient
    .get('/api/purchase-orders/products', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getUOM = (Options = {}) => {
  return httpClient
    .get('/api/purchase-orders/uom', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const printPdf = id => {
  return httpClient
    .get(`/api/purchase-orders/${id}/print-pdf`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  getSupplier,
  getProduct,
  printPdf,
  getUOM
}
